import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter",
  "use": "filter-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol viewBox=\"0 0 18 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"filter\">\n    <path d=\"M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z\" fill=\"#2F2F2F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol